import theme from '../../../../theme';
export type ColorSchemeType = {
  colors: Array<string>;
};

export const COLOR_SCHEME_REPORTS: ColorSchemeType = {
  colors: [
    theme.admanColors!.blue.dark.bg1[0],
    theme.admanColors!.blue.dark.bg1[3],
    theme.admanColors!.blue.dark.bg1[4],
    theme.admanColors!.blue.dark.bg1[5],
    theme.admanColors!.blue.dark.bg1[6],
  ],
};

export const TOOLTIP =
  'Data Represents Sales Orders Initially Selected. For more information, please reach out to your Disney Account Manager.';
